// import "./TFDAccelerateLittleSuperstars.css";
import "./AccelerateGlobal.css";

import { Link } from "react-router-dom";
import React from "react";

export default function TFDAccelerateLittleSuperstars() {
  return (
    <div className="tfd-accelerate-little-superstars-page">
      {/* HERO SECTION */}
      <section className="tf-hero-little-superstars">
        <div className="hero-image-wrap">
          <img
            src="/images/accelerate/little-superstars-hero.jpg"
            alt="Little Superstars Hero"
            className="hero-bg-image"
          />
          <div className="overlay-dark" />
          <div className="hero-content themeflat-container">
            <h1 className="hero-title wow fadeInUp animated">
              TFD ACCELERATE Little Superstars
            </h1>
            <p className="hero-subtitle wow fadeInUp animated">
              Inspiring the next generation of football prodigies through fun and skill.
            </p>
            <Link to="/contact" className="flat-button wow fadeInUp animated">
              Discover More
            </Link>
          </div>
        </div>
      </section>

      {/* INFO SECTION */}
      <section className="tf-little-superstars-info main-content">
        <div className="themeflat-container">
          <div className="row align-items-center">
            <div className="col-md-6 wow fadeInLeft animated">
              <div className="title-box title-small-v2">
                <span className="sub-title">Why Little Superstars?</span>
                <h2 className="title-section">
                  Nurturing Young Talent with Fun and Fundamentals
                </h2>
              </div>
              <p className="post">
                Our Little Superstars program is designed for children aged 4-7, introducing them to the fundamentals of football in a fun, supportive, and safe environment. With playful drills, engaging activities, and a focus on building confidence, we help spark a lifelong love for the game.
              </p>
              <ul className="list-check">
                <li>
                  <strong>Fun Learning Environment:</strong> Games and activities tailored for young minds.
                </li>
                <li>
                  <strong>Age-Appropriate Coaching:</strong> Trainers who know how to engage and inspire.
                </li>
                <li>
                  <strong>Fundamental Skills Development:</strong> Building a solid base in technique and coordination.
                </li>
                <li>
                  <strong>Positive Team Spirit:</strong> Encouraging social interaction and teamwork.
                </li>
              </ul>
              <Link to="/contact" className="flat-button mt-3">
                Enroll Today
              </Link>
            </div>
            <div className="col-md-6 wow fadeInRight animated">
              <div className="image-wrapper">
                <img
                  src="/images/accelerate/little-superstars-info.jpg"
                  alt="Little Superstars Training"
                  className="image-gr"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="tf-little-superstars-cta main-content">
        <div className="themeflat-container text-center">
          <Link to="/contact" className="flat-button big-cta-button wow fadeInUp animated">
            Get Started
          </Link>
        </div>
      </section>
    </div>
  );
}
